import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";
import { rtlRotate180 } from "plos/src/styles/utils.css";

export const chevronStyle = style([
  rtlRotate180,
  {
    fill: vars.colors.onPrimary,
  },
]);

export const prevIconStyle = style({
  marginInlineEnd: "0.6rem",
  verticalAlign: "middle",
  fill: "currentColor",
});

export const nextIconStyle = style({
  marginInlineStart: "0.6rem",
  verticalAlign: "middle",
  fill: "currentColor",
});
